export const STATUS = {
  AWAITING_RESPONSE: 'AWAITING_RESPONSE',
  RESPONSE_RECEIVED: 'RESPONSE_RECEIVED',
  CLOSED: 'CLOSED'
};

export const IMPORTANCE = {
  MOST_IMPORTANT: 'MOST_IMPORTANT',
  IMPORTANT: 'IMPORTANT',
  SLIGHTLY_IMPORTANT: 'SLIGHTLY_IMPORTANT',
  BLANK: 'BLANK'
};
